import React from 'react';
import { Hero } from '../components/Hero';
import { Link } from 'react-router-dom';
import { ArrowRight, Film, Briefcase, Share2, Camera, CheckCircle, MessageCircle } from 'lucide-react';
import ProcessTimeline from '../components/ProcessTimeline';
import FAQSection from '../components/FAQSection';
import './HomePage.css';

const HomePage = () => {
  const services = [
    { 
      icon: Film, 
      title: 'Wedding Films', 
      description: 'Cinematic highlights, teasers, and full wedding films edited remotely for global studios'
    },
    { 
      icon: Briefcase, 
      title: 'Corporate Videos', 
      description: 'Brand films, presentations, and promotional videos crafted for businesses'
    },
    { 
      icon: Share2, 
      title: 'Social Media', 
      description: 'High-impact reels, YouTube edits, and short-form content optimized for engagement'
    },
    { 
      icon: Camera, 
      title: 'Event Coverage', 
      description: 'Professional editing for events, conferences, and special occasions'
    }
  ];

  const features = [
    { text: 'Professional-grade editing standards', icon: CheckCircle },
    { text: 'Fast and reliable turnaround time', icon: CheckCircle },
    { text: 'Structured revision process', icon: CheckCircle },
    { text: 'Transparent & fair pricing', icon: CheckCircle }
  ];

  return (
    <div className="home-page">
      {/* Hero Section */}
      <Hero />

      {/* Services Highlight */}
      <section className="services-highlight section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">What We Do Best</h2>
            <p className="section-subtitle">
              Specialized video editing services that bring your vision to life
            </p>
          </div>
          <div className="services-highlight-grid">
            {services.map((service, index) => {
              const Icon = service.icon;
              return (
                <div key={index} className="service-highlight-card">
                  <div className="service-highlight-icon">
                    <Icon size={28} />
                  </div>
                  <h3 className="service-highlight-title">{service.title}</h3>
                  <p className="service-highlight-description">{service.description}</p>
                </div>
              );
            })}
          </div>
          <div className="section-cta">
            <Link to="/services" className="btn btn-secondary">
              <span>View All Services</span>
              <ArrowRight size={20} />
            </Link>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="why-choose section">
        <div className="container">
          <div className="why-choose-content">
            <div className="why-choose-text">
              <h2 className="section-title">Why Choose RSE?</h2>
              <p className="why-description">
                With 8+ years of experience and over 5630 successfully delivered projects, RSE Post Production 
                House partners with filmmakers and studios worldwide to handle post-production seamlessly.
              </p>
              <ul className="features-list">
                {features.map((feature, index) => {
                  const Icon = feature.icon;
                  return (
                    <li key={index} className="feature-item">
                      <Icon size={20} />
                      <span>{feature.text}</span>
                    </li>
                  );
                })}
              </ul>
              <Link to="/about" className="btn btn-secondary">
                Learn More About Us
              </Link>
            </div>
            <div className="why-choose-image">
              <img 
                src="https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?w=600&q=80" 
                alt="Video Editing"
                className="why-image"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Process Timeline */}
      <ProcessTimeline />

      {/* FAQ Section */}
      <FAQSection />

      {/* CTA Section */}
      <section className="home-cta">
        <div className="container">
          <div className="cta-content">
            <h2 className="cta-title">Looking for a Reliable Post-Production Partner?</h2>
            <p className="cta-description">
              From raw footage to final masterpiece — let our expert editors help you deliver cinematic films faster.
            </p>
            <div className="cta-buttons">
              <Link to="/booking" className="cta-btn-primary">
                <span>Book Your Slot</span>
                <ArrowRight size={18} />
              </Link>
              <Link to="/contact" className="cta-btn-secondary">
                <MessageCircle size={18} />
                <span>Let's Talk</span>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
